import * as React from 'react';
import { API_DATE_FORMAT, format, removeDotsFromDate } from '../../utils';
import ServiceSummary from '../../ServiceSummary';
import ServiceSummaryOption from '../../ServiceSummary/components/ServiceSummaryOption';
import { parse } from 'date-fns';
import { useContext } from 'react';
import { CartContext } from '../Cart';
import { useTranslation } from 'react-i18next';
import ServiceSummaryDivider from '../../ServiceSummary/components/ServiceSummaryDivider/ServiceSummaryDivider';
import { CheckoutSteps } from '../../MobileStepbar/types';
import { CdnIcon } from '@shared/ui';
import { getPassengerFaresBySegmentGroups } from '../utils';
import { useConfig } from '../../context';
import { useShowTaxesInfo } from '../../hooks';
const FareIcons = {
    ADT: 'Info/Passengers',
    CNN: 'Tour/Child',
    INF: 'Baggage/Baby carriage',
    INS: 'Tour/Child'
};
const Flights = ({ flight, renderService, hideFlightPrice, activeStep, steps }) => {
    var _a;
    const cartContext = useContext(CartContext);
    const { t } = useTranslation('Cart');
    const { splitCartFlightPassengers } = useConfig().global;
    const showTaxesInfo = useShowTaxesInfo();
    const groupOptions = React.useMemo(() => {
        const groupOptions = [];
        const passengerFaresBySegmentGroups = showTaxesInfo
            ? getPassengerFaresBySegmentGroups(flight, splitCartFlightPassengers)
            : null;
        const passengerTypeCache = new Map();
        const getPassengerTypeName = (type, count) => {
            const key = `${type}_${count}`;
            if (!passengerTypeCache.has(key)) {
                passengerTypeCache.set(key, t(type, { ns: 'PassengerTypes', count }));
            }
            return passengerTypeCache.get(key);
        };
        flight.segmentGroups.forEach(segment => {
            var _a;
            const firstSegment = segment.segments[0];
            const lastSegment = segment.segments[segment.segments.length - 1];
            const departureDate = parse(firstSegment.departure.date, API_DATE_FORMAT, new Date());
            const formattedDate = removeDotsFromDate(format(departureDate, 'dd MMM, EEEEEE'));
            groupOptions.push({
                header: `${firstSegment.departure.airport.city.name} — ${lastSegment.arrival.airport.city.name}`,
                headerIcon: React.createElement(CdnIcon, { icon: 'Flight/Direction' }),
                items: [
                    {
                        id: 'date',
                        name: `${formattedDate} • ${firstSegment.departure.time} - ${lastSegment.arrival.time}`
                    },
                    {
                        id: 'fare',
                        name: (_a = segment.fareFamily) === null || _a === void 0 ? void 0 : _a.title,
                        price: !hideFlightPrice ? segment.price : undefined
                    }
                ]
            });
            if (passengerFaresBySegmentGroups) {
                const passengerFares = passengerFaresBySegmentGroups.get(segment.groupId);
                if (passengerFares) {
                    const passengerNumbers = new Map();
                    passengerFares.forEach(passengerFare => {
                        var _a;
                        const currentNumber = passengerNumbers.get(passengerFare.passengerType) || 0;
                        passengerNumbers.set(passengerFare.passengerType, currentNumber + 1);
                        const items = [
                            {
                                id: 'baseFarePrice',
                                name: t('Fare'),
                                price: passengerFare.baseFare
                            }
                        ];
                        if (passengerFare.totalTaxes) {
                            items.push({
                                id: 'totalTaxesPrice',
                                name: t('Tax'),
                                price: passengerFare.totalTaxes
                            });
                        }
                        const passengerTypeName = getPassengerTypeName(passengerFare.passengerType, passengerFare.count);
                        const header = splitCartFlightPassengers
                            ? `${passengerTypeName} ${currentNumber + 1}`
                            : `${passengerFare.count} ${passengerTypeName}`;
                        const icon = (_a = FareIcons[passengerFare.passengerType]) !== null && _a !== void 0 ? _a : FareIcons['ADT'];
                        groupOptions.push({
                            description: 'paxesDetails',
                            id: `${segment.groupId}_${passengerFare.passengerType}`,
                            header,
                            headerIcon: React.createElement(CdnIcon, { icon: icon }),
                            items
                        });
                    });
                }
            }
        });
        return groupOptions;
    }, [flight, hideFlightPrice, showTaxesInfo, splitCartFlightPassengers, t]);
    const group = {
        header: t('Flights'),
        icon: React.createElement(CdnIcon, { icon: "Flight/Direction" }),
        totalPrice: !hideFlightPrice ? (_a = cartContext.totalPrices) === null || _a === void 0 ? void 0 : _a.flights : undefined,
        disabled: activeStep < (steps === null || steps === void 0 ? void 0 : steps.findIndex(step => step.type === CheckoutSteps.Flights)) || false
    };
    const content = (React.createElement(React.Fragment, null,
        React.createElement(ServiceSummaryDivider, null, groupOptions.map(groupOption => (React.createElement(ServiceSummaryOption, { groupOption: groupOption, key: groupOption.id || groupOption.header }))))));
    if (!groupOptions.length) {
        return null;
    }
    if (renderService) {
        return renderService(CheckoutSteps.Flights, group, content);
    }
    return React.createElement(ServiceSummary, { group: group }, content);
};
export default Flights;
